import { i18next } from '@frontend/i18n';
import { RegisterTerminalModalJustifiSteps, RegisterTerminalModalStripeSteps } from './hooks';
import { RegisterTerminalModalType } from './types';

export const STRIPE_REGISTER_TERMINAL_STEPS_TITLES = {
  [RegisterTerminalModalStripeSteps.InstallBattery]: {
    title: i18next.t('Power Up Terminal', { ns: 'payments' }),
    heading: i18next.t('Power Up Terminal', { ns: 'payments' }),
  },
  [RegisterTerminalModalStripeSteps.PlugInTerminal]: {
    title: i18next.t('Power Up Terminal', { ns: 'payments' }),
    heading: i18next.t('Power Up Terminal', { ns: 'payments' }),
  },
  [RegisterTerminalModalStripeSteps.TurnTerminalOn]: {
    title: i18next.t('Power Up Terminal', { ns: 'payments' }),
    heading: i18next.t('Power Up Terminal', { ns: 'payments' }),
  },
  [RegisterTerminalModalStripeSteps.ConnectToNetwork]: {
    title: i18next.t('Connect to Network', { ns: 'payments' }),
    heading: i18next.t('Connect to Network', { ns: 'payments' }),
  },
  [RegisterTerminalModalStripeSteps.GeneratePairingCode]: {
    title: i18next.t('Register Terminal', { ns: 'payments' }),
    heading: i18next.t('Register Your Terminal', { ns: 'payments' }),
  },
  [RegisterTerminalModalStripeSteps.PairYourTerminal]: {
    title: i18next.t('Register Terminal', { ns: 'payments' }),
    heading: i18next.t('Register Your Terminal', { ns: 'payments' }),
  },
};

// below steps are new designs enables via a weTag
export const STRIPE_S710_REGISTER_TERMINAL_STEPS_TITLES = {
  [RegisterTerminalModalStripeSteps.SetupTerminal]: {
    title: i18next.t('Power Up Terminal', { ns: 'payments' }),
    heading: i18next.t('Power Up Terminal', { ns: 'payments' }),
  },
  [RegisterTerminalModalStripeSteps.ConnectWifi]: {
    title: i18next.t('Connect to Network', { ns: 'payments' }),
    heading: i18next.t('Connect to Network', { ns: 'payments' }),
  },
  [RegisterTerminalModalStripeSteps.RegisterTerminal]: {
    title: i18next.t('Register Terminal', { ns: 'payments' }),
    heading: i18next.t('Register Terminal', { ns: 'payments' }),
  },
};

export const JUSTIFI_REGISTER_TERMINAL_STEPS_TITLES = {
  [RegisterTerminalModalJustifiSteps.PreCheck]: {
    title: i18next.t('Power Up Terminal', { ns: 'payments' }),
    heading: i18next.t('Power Up Terminal', { ns: 'payments' }),
  },
  [RegisterTerminalModalJustifiSteps.TurnOnTerminal]: {
    title: i18next.t('Power Up Terminal', { ns: 'payments' }),
    heading: i18next.t('Power Up Terminal', { ns: 'payments' }),
  },
  [RegisterTerminalModalJustifiSteps.ConnectToWifiStep1]: {
    title: i18next.t('Connect to Network', { ns: 'payments' }),
    heading: i18next.t('Connect Terminal to WiFi', { ns: 'payments' }),
  },
  [RegisterTerminalModalJustifiSteps.ConnectToWifiStep2]: {
    title: i18next.t('Connect to Network', { ns: 'payments' }),
    heading: i18next.t('Connect Terminal to WiFi', { ns: 'payments' }),
  },
  [RegisterTerminalModalJustifiSteps.ConnectToWifiStep3]: {
    title: i18next.t('Connect to Network', { ns: 'payments' }),
    heading: i18next.t('Connect Terminal to WiFi', { ns: 'payments' }),
  },
  [RegisterTerminalModalJustifiSteps.IncorrectPassword]: {
    title: i18next.t('Connect to Network', { ns: 'payments' }),
    heading: i18next.t('Connect Terminal to WiFi', { ns: 'payments' }),
  },
  [RegisterTerminalModalJustifiSteps.GenrateDeviceId]: {
    title: i18next.t('Register Terminal', { ns: 'payments' }),
    heading: i18next.t('Register Your Terminal', { ns: 'payments' }),
  },
};

export interface StepperStep {
  id: string;
  title: string;
}

const TERMINAL_CONFIG = {
  [RegisterTerminalModalType.Justifi]: {
    stepTitles: JUSTIFI_REGISTER_TERMINAL_STEPS_TITLES,
    initialStep: RegisterTerminalModalJustifiSteps.PreCheck,
  },
  [RegisterTerminalModalType.StripeS710]: {
    stepTitles: STRIPE_S710_REGISTER_TERMINAL_STEPS_TITLES,
    initialStep: RegisterTerminalModalStripeSteps.SetupTerminal,
  },
  [RegisterTerminalModalType.Stripe]: {
    stepTitles: STRIPE_REGISTER_TERMINAL_STEPS_TITLES,
    initialStep: RegisterTerminalModalStripeSteps.InstallBattery,
  },
};

const getTerminalType = (hasJustifyOnboardingEnabled: boolean, S710TerminalDesignsWetag: boolean) => {
  if (hasJustifyOnboardingEnabled) return RegisterTerminalModalType.Justifi;
  if (S710TerminalDesignsWetag) return RegisterTerminalModalType.StripeS710;
  return RegisterTerminalModalType.Stripe;
};

export const getSteppersData = (hasJustifyOnboardingEnabled: boolean, S710TerminalDesignsWetag: boolean) => {
  const type = getTerminalType(hasJustifyOnboardingEnabled, S710TerminalDesignsWetag);
  const { stepTitles, initialStep } = TERMINAL_CONFIG[type];

  const steps: StepperStep[] = Object.entries(stepTitles).map(([id, { title }]) => ({ id, title }));

  return { initialStep, type, steps };
};
